import { render } from "./leftside.vue?vue&type=template&id=2c0b6e7d&scoped=true"
import script from "./leftside.vue?vue&type=script&lang=js"
export * from "./leftside.vue?vue&type=script&lang=js"

import "./leftside.vue?vue&type=style&index=0&id=2c0b6e7d&scoped=true&lang=scss"
import "./leftside.vue?vue&type=style&index=1&id=2c0b6e7d&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0b6e7d"]])

export default __exports__